import WizardHeader from './WizardHeader'

export default WizardHeader